export enum LabsRouteNames {
  LABS = 'labs',
}

export enum LabsRoutePathNames {
  LABS = 'labs',
}

export enum LabsLocalePrefix {
  LABS = 'labs',
}

export enum LabsViews {
  FEATURED = 'featured',
  ALL = 'all',
  MY_ACCESS = 'my-access',
}
